import React, { useCallback, useEffect, useState } from "react"
import { connect, ConnectedProps } from "react-redux"
import classnames from "classnames"
import { NavLink } from "react-router-dom"
import { Menu, Nav, Sidebar, CloseSidebar, Action } from "./SideNav.styles"
// import { HLog } from "src/core/helpers"
import SideNavHeader from "./SideNavHeader"
import { MyIcon, MyModal } from "src/core/components"
import { MdKeyboardArrowLeft } from "react-icons/md"
import { toggleSideNav } from "src/App/App.actions"
import { useTranslation } from "react-i18next"
import { HEE, HLocalStorage, MyUI } from "@macashipo/mlib"
import { HApi } from "src/core/helpers"
import { ScreenCode, Path } from "src/modules/app_dnt/constants/path"
import { setHomepageUrl } from "src/core/helpers/auth"
import { signalRTypes } from "src/App/App.constants"
import { getKeyMenuLocal } from "src/core/helpers/auth"
import { Button } from "reactstrap"

// const useForceUpdate = () => {
//   const [count, setCount] = React.useState(0)
//   const increment = () => setCount(count + 1)
//   return [increment, count] as any
// }

const mapStateToProps = state => ({
  closeSideNav: state.app.closeSideNav,
  sideNavItems: state.app.sideNavItems,
  sideButtonList: state.app.sideButtonList,
})

const mapDispatchToProps = {
  toggleSideNav,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

interface Props extends ConnectedProps<typeof connector> {
  fnList?: any
}

function SideNav(props: Props) {
  const { closeSideNav, sideNavItems, sideButtonList, toggleSideNav, fnList } =
    props
  const { t } = useTranslation()
  const keyMenuLocal = getKeyMenuLocal()
  const fieldCount = {
    [ScreenCode.MY_TASKS]: "CountMyTask",
    [ScreenCode.MY_COMMUNICATIONS]: "CountMyCommunication",
  }
  const signalType = `ers_${signalRTypes.myTaskAndCommunicationCount}`
  const [counts, setCounts] = useState(null as any)
  const [configMenuShow, setConfigMenuShow] = useState(
    HLocalStorage.getObj(keyMenuLocal, [])
  )
  // const [forceUpdateFnc, forceUpdateValue] = useForceUpdate()
  const keyDraft = "_count_draft"
  const receiveSignalUpdate = useCallback(
    obj => {
      if (obj) {
        const newObj = {
          [fieldCount[ScreenCode.MY_TASKS]]: obj.countMyTask,
          [fieldCount[ScreenCode.MY_COMMUNICATIONS]]: obj.countMyCommunication,
        }
        setCounts(newObj)
        const prevObj = HLocalStorage.getObj(keyDraft, {})
        if (
          prevObj?.[fieldCount[ScreenCode.MY_TASKS]] !==
          newObj[fieldCount[ScreenCode.MY_TASKS]]
        ) {
          const badge = document.getElementById(fieldCount[ScreenCode.MY_TASKS])
          if (badge) {
            badge.classList.add("heart-beat")
            setTimeout(() => {
              badge.classList.remove("heart-beat")
            }, 2000)
          }
        }
        if (
          prevObj?.[fieldCount[ScreenCode.MY_COMMUNICATIONS]] !==
          newObj[fieldCount[ScreenCode.MY_COMMUNICATIONS]]
        ) {
          const badge = document.getElementById(
            fieldCount[ScreenCode.MY_COMMUNICATIONS]
          )
          if (badge) {
            badge.classList.add("heart-beat")
            setTimeout(() => {
              badge.classList.remove("heart-beat")
            }, 2000)
          }
        }
        HLocalStorage.saveObj(keyDraft, newObj)
        // forceUpdateFnc()
      }
    },
    // eslint-disable-next-line
    []
  )
  useEffect(() => {
    requestFirst()
    HEE.on(signalType, receiveSignalUpdate)
    return () => {
      HEE.removeListener(signalType, receiveSignalUpdate, null, false)
    }
    // eslint-disable-next-line
  }, [])
  const requestFirst = () => {
    // Skip API call if Login is already handling Menu/MenuInfo in this session
    const menuJustFetched = sessionStorage.getItem("_menuFetchedByLogin")
    if (menuJustFetched) {
      sessionStorage.removeItem("_menuFetchedByLogin")
      const cachedMenu = HLocalStorage.getObj(keyMenuLocal, [])
      if (cachedMenu.length > 0) {
        setConfigMenuShow(cachedMenu)
        if (fnList?.updateMenuShowList) {
          fnList.updateMenuShowList(getMenuShow(cachedMenu))
        }
      }
      return // Always skip API call when Login already fetched (or is fetching) the menu
    }
    HApi.apiGeneric({
      method: "POST",
      url: "Menu/MenuInfo",
      data: {},
    })
      .then(response => {
        const data = response.Data
        if (data) {
          let configCounts: any = {}
          Object.keys(fieldCount).forEach(v => {
            if (data[fieldCount[v]]) {
              configCounts[fieldCount[v]] = data[fieldCount[v]]
            }
          })
          setCounts(configCounts)
          HLocalStorage.saveObj(keyDraft, configCounts)
          if (data.MenuList) {
            setConfigMenuShow(data.MenuList)
            HLocalStorage.saveObj(keyMenuLocal, data.MenuList)
            if (fnList?.updateMenuShowList) {
              fnList.updateMenuShowList(getMenuShow(data.MenuList))
            }
            const homepageItem = data.MenuList.find(
              (v: any) => v.IsHomepage === true
            )
            if (homepageItem) {
              setHomepageUrl(
                homepageItem.UIUrl || Path[homepageItem.ScreenCode] || "/"
              )
            }
          }
        }
      })
      .catch(error => {})
  }
  const getMenuShow = (fromList: any = null) => {
    const menuList = fromList || configMenuShow
    let mn: any = []
    if (menuList) {
      menuList.forEach(v => {
        mn.push(v.ScreenCode)
      })
    }
    return mn
  }
  const getIsShowAction = () => {
    const menuShow = getMenuShow()
    let isShow = false
    if (sideButtonList?.length > 0) {
      sideButtonList.forEach(v => {
        if (menuShow.includes(v.code)) {
          isShow = true
          return
        }
      })
    }
    return isShow
  }
  if (closeSideNav === true) {
    window.document.body.classList.add("sidebar-close")
    window.document.body.classList.remove("sidebar-open")
  } else {
    window.document.body.classList.add("sidebar-open")
    window.document.body.classList.remove("sidebar-close")
  }
  const renderMenu = () => {
    return (
      <Menu className="list-unstyled">
        {configMenuShow &&
          configMenuShow.length > 0 &&
          configMenuShow.map((menuItem: any, i: number) => {
            const v =
              sideNavItems &&
              sideNavItems.find((s: any) => s.code === menuItem.ScreenCode)
            if (!v) return null
            const count = counts?.[fieldCount[v.code]]
            return (
              <li key={i}>
                <NavLink
                  exact
                  to={v.url}
                  onClick={() => {
                    if (window.innerWidth <= 768) {
                      toggleSideNav()
                    }
                  }}
                >
                  <MyIcon data={v.icon} />
                  <span style={{ marginLeft: "5px" }}>{t(v.name)}</span>
                  {count > 0 && (
                    <div id={fieldCount[v.code]} className="count">
                      {count}
                    </div>
                  )}
                </NavLink>
              </li>
            )
          })}
      </Menu>
    )
  }
  const renderHeaderModal = (text, code) => {
    if (t(`dnt:guidelines.${code}`)) {
      return (
        <div className="md-header-guideline-stick">
          <div>{text}</div>
          <MyUI
            type="guideline"
            content={t(`dnt:guidelines.${code}`)}
            inModal={true}
          />
        </div>
      )
    }
    return text
  }
  const renderAction = () => {
    const menuShow = getMenuShow()
    if (getIsShowAction()) {
      return (
        <Action>
          {sideButtonList.map((v, i) => {
            if (menuShow.includes(v.code)) {
              const count = counts?.[fieldCount[v.code]]
              return (
                <Button
                  key={i}
                  color="primary-less"
                  onClick={() => {
                    if (v.type === "modal" && v.configPage) {
                      MyModal.showFromMyPage(
                        {
                          ...v.configPage,
                          MoreProps: {
                            isInPopup: true,
                          },
                        },
                        {
                          title: renderHeaderModal(t(v.name), v.code),
                          dragable: true,
                          size: "xl no-scroll modal-bs-background",
                        }
                      )
                    }
                  }}
                >
                  <MyIcon data={v.icon} />
                  <span style={{ marginLeft: "5px" }}>{t(v.name)}</span>
                  {count > 0 && (
                    <div id={fieldCount[v.code]} className="count">
                      {count}
                    </div>
                  )}
                </Button>
              )
            }
            return null
          })}
        </Action>
      )
    }
  }
  return (
    <Sidebar className="no-print">
      <Nav className={classnames("c-sidebar", closeSideNav ? "close" : "")}>
        <CloseSidebar className="close-sidebar">
          <button className="btn btn-primary-light" onClick={toggleSideNav}>
            <MdKeyboardArrowLeft size={20} />
          </button>
        </CloseSidebar>
        <SideNavHeader />
        {renderMenu()}
        {renderAction()}
      </Nav>
      <div
        className={`overlay ${closeSideNav ? "close" : "open"}`}
        onClick={() => {
          toggleSideNav()
        }}
      ></div>
      <MyUI type="bottom_toast" />
    </Sidebar>
  )
}

export default connector(SideNav)
